import isClient from 'commons/isClient';
import queryString from 'query-string';

export const getCheckoutToken = () => {
  // get affirm token on page load
  const { checkout_token } = isClient()
    ? queryString.parse(window.location.search)
    : {};
  return checkout_token;
};

export const getCheckoutRef = () => {
  // get affirm token on page load
  const { checkout_ref } = isClient()
    ? queryString.parse(window.location.search)
    : {};
  return checkout_ref;
};
